/**
   * Switcher control for toggle values
   *
   * @param {String} name name of the input
   * @param {String} label for the switch
   * @param {String} sublabel Shows under the label
   * @param {Boolean} hideLabel condition for hiding label
   * @param {Object} modelValue model value
   * @param {Function} change change function fires on toggle
   *
   */
function switcher() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./switcher.html'),
    scope: {},
    controller: SwitcherController,
    controllerAs: 'vm',
    bindToController: {
      name: '@',
      label: '@',
      subLabel: '@',
      hideLabel: '=?',
      modelValue: '=',
      change: '&?',
      ngDisabled: '=',
      modelOptions: '='
    }
  };
}

function SwitcherController(Helper) {
  'ngInject';
  var vm = this;

  const modelOptions = vm.modelOptions || {};

  vm.onChange = onChange;

  vm.options = {
    ...modelOptions,
    '*': '$inherit'
  };

  function onChange() {
    Helper.ready(vm.change);
  }

}

export { switcher };
